import { Alert } from '@vtex/shoreline'
import { t } from 'i18next'

import Panel from '~/components/Panel'
import Table from '~/components/Table'
import ThumbProduct from '~/components/ThumbProduct'
import { Image } from '~/modules/retailMedia/components/ProductsTable/styles'

type ReviewCampaignProduct = {
  id: string
  name: string
  sku: string
  image_url?: string | null
}

const schema = (): TableSchema<ReviewCampaignProduct> => ({
  title: {
    title: t('rm:Product'),
    render: rowData => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Image>
          <ThumbProduct url={rowData.image_url} title={rowData.name} />
        </Image>

        <div style={{ lineHeight: 1 }}>
          <strong className="title">{rowData.name}</strong>
          <br />
          <span className="text-sm">SKU: {rowData.sku}</span>
        </div>
      </div>
    ),
    className: 'order__details col__infos col__title'
  }
})

const ReviewCampaignProducts = ({
  products
}: {
  products: ReviewCampaignProduct[]
}) => {
  return (
    <Panel
      template="shoreline"
      title={t('rm:relatedProducts')}
      isCollapsible
      noPaddingBody={products.length > 0}
    >
      {products.length === 0 ? (
        <div data-testid="review-campaign-products-empty">
          <Alert variant="informational">{t('rm:relatedProducts.empty')}</Alert>
        </div>
      ) : (
        <div data-testid="review-campaign-products">
          <Table
            schema={schema()}
            data={products}
            hasHeader={false}
            striped
            sideBorder
            smallerRowPadding
          />
        </div>
      )}
    </Panel>
  )
}

export default ReviewCampaignProducts
